/* eslint-disable no-script-url */

import React from 'react';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Title from './title';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import clsx from 'clsx';

const useStyles = makeStyles (theme => ({
  depositContext: {
    padding: '10px 0',
    flex: 1,
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    textAlign: 'center',
  },
  link: {
    color: '#CFD11A',
  }
}));

export default function Analytics() {
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  return (
    <React.Fragment>
    {/* Online Traffic */}
    <Grid item xs={12} md={4} lg={3}>
      <Paper className={fixedHeightPaper}>
      <Title>Conversion rate</Title>
      <Typography component="p" variant="h4">
        3.22%
      </Typography>
      <Typography color="textSecondary" className={classes.depositContext}>
      This month (Above Average)
      </Typography>
        <Link className={classes.link} href="javascript:;">
          View report
        </Link>
      </Paper>
    </Grid>

    {/* Online Traffic */}
    <Grid item xs={12} md={4} lg={3}>
      <Paper className={fixedHeightPaper}>
      <Title>Return customers</Title>
      <Typography component="p" variant="h4">
        5.43%
      </Typography>
      <Typography color="textSecondary" className={classes.depositContext}>
      This month
      </Typography>
      <div>
        <Link className={classes.link} href="javascript:;">
          View report
        </Link>
      </div>
      </Paper>
    </Grid>

    {/* Online Traffic */}
    <Grid item xs={12} md={4} lg={3}>
      <Paper className={fixedHeightPaper}>
      <Title>Online traffic</Title>
      <Typography component="p" variant="h4">
        7,993,580
      </Typography>
      <Typography color="textSecondary" className={classes.depositContext}>
      This month
      </Typography>
      <div>
        <Link className={classes.link} href="javascript:;">
          View report
        </Link>
      </div>
      </Paper>
    </Grid>

    {/* Online Traffic */}
    <Grid item xs={12} md={4} lg={3}>
      <Paper className={fixedHeightPaper}>
      <Title>Online traffic by location</Title>
      <Typography component="p" variant="h4">
        7,993,580
      </Typography>
      <Typography color="textSecondary" className={classes.depositContext}>
      This month
      </Typography>
      <div>
        <Link className={classes.link} href="javascript:;">
          View report
        </Link>
      </div>
      </Paper>
    </Grid>
    </React.Fragment>
  );
}
